import * as Tone from 'tone';
import AudioEffect from './AudioEffect';
import { optionsFromArguments } from 'tone';
class Limiter extends AudioEffect {
    constructor() {
        super();
        const options = optionsFromArguments(defaults, arguments, // eslint-disable-line prefer-rest-params
        ['ceiling', 'gain', 'release']);
        this.compressor = new Tone.Compressor({
            attack: 0.001,
            release: options.release,
            threshold: options.ceiling
        });
        this.gainNode = new Tone.Gain(options.gain, "decibels");
        this.gainNode.connect(this.compressor);
    }
    input() { return this.gainNode; }
    output() { return this.compressor; }
    get ceiling() {
        return this.compressor.threshold;
    }
    get gain() {
        return this.gainNode.gain;
    }
    get release() {
        return this.compressor.release;
    }
}
const defaults = {
    ceiling: -0.3,
    gain: 0,
    release: 0.3
};
export default Limiter;
//# sourceMappingURL=Limiter.js.map